import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../fopForm/FopForm.css";
import { Typography, Tabs, Tab, Box, Button } from '@mui/material';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const FOPForm = () => {
  const [contractors, setContractors] = useState([]);
  const [setRestaurants] = useState([]);
  const [fopData, setFopData] = useState({
    name_fop: '',
    contractor_id: '',
    rest_id: ''
  });
  const [tabValue, setTabValue] = useState(0);
  const [selectedContractor, setSelectedContractor] = useState('');
  const [contractorRestaurants, setContractorRestaurants] = useState([]);
  const [existingFops, setExistingFops] = useState([]);

  const pacOptions = [
    { label: 'PRO', value: 'PRO', limit: 6 },
    { label: 'EXCLUSIVE', value: 'EXCLUSIVE', limit: 6 },
    { label: 'Chain: START Chain', value: 'START_CHAIN', limit: 10 },
    { label: 'PRO Chain', value: 'PRO_CHAIN', limit: 15 },
    { label: 'EXCLUSIVE Chain', value: 'EXCLUSIVE_CHAIN', limit: 20 }
  ];

  useEffect(() => {
    fetchContractors();
    fetchRestaurants();
    fetchExistingFops();
  }, []); 

  const fetchContractors = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/contractors-with-fop-count');
      setContractors(response.data);
    } catch (error) {
      console.error('Error fetching contractors:', error);
    }
  };

  const fetchRestaurants = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/restaurants');
      setRestaurants(response.data); 
    } catch (error) {
      console.error('Error fetching restaurants:', error);
    }
  };

  const fetchExistingFops = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/existing-fops');
      setExistingFops(response.data);
    } catch (error) {
      console.error('Error fetching existing FOPs:', error);
    }
  };

  const handleChange = (e) => {
    setFopData({ ...fopData, [e.target.name]: e.target.value });
  };

  const handleContractorSelect = (e) => {
    const contractorId = e.target.value;
    setSelectedContractor(contractorId);
    setFopData({ ...fopData, contractor_id: contractorId, rest_id: '' });
  };

  const handleProcessContractor = async () => {
    if (selectedContractor) {
      try {
        const response = await axios.get(`https://bank2.daolog.net/restaurants-by-contractor/${selectedContractor}`);
        setContractorRestaurants(response.data);
      } catch (error) {
        console.error('Error fetching contractor restaurants:', error);
        alert('Помилка при отриманні ресторанів контрагента');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://bank2.daolog.net/create-fop', fopData);
      alert('FOP запис успішно створено');
      setFopData({ name_fop: '', contractor_id: '', rest_id: '' });
      fetchExistingFops();
    } catch (error) {
      console.error('Error creating FOP:', error);
      alert('Помилка при створенні FOP запису');
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleFopAmountChange = async (contractorId, pac) => {
    try {
      const selectedOption = pacOptions.find(option => option.value === pac);
      if (!selectedOption) {
        throw new Error('Invalid PAC option');
      }

      await axios.put(`https://bank2.daolog.net/update-fop-amount/${contractorId}`, {
        fop_amount: selectedOption.limit,
        pac: selectedOption.value
      });
      fetchExistingFops();
    } catch (error) {
      console.error('Error updating FOP amount:', error);
      alert('Помилка при оновленні кількості ФОП: ' + error.message);
    }
  };

  return (
    <div className="br-m" style={{ marginTop: "120px" }}>
      <div className="container-about-use">
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Створення FOP" />
            <Tab label="Існуючі FOP" />
          </Tabs>
        </div>

        <TabPanel value={tabValue} index={0}>
        <Typography variant="h5" component="div" gutterBottom>
  Створення FOP запису
</Typography>
          <form onSubmit={handleSubmit}>
            <select
              className="input-stl"
              style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
              name="contractor_id"
              value={fopData.contractor_id}
              onChange={handleContractorSelect}
              required
            >
              <option style={{ backgroundColor: "rgb(213, 220, 255"}} value="">Виберіть контрагента</option>
              {contractors.map(contractor => (
                <option key={contractor.id} value={contractor.id}>
                  {contractor.name} (Створено {contractor.current_fop_count} з {contractor.fop_amount})
                </option>
              ))}
            </select>

            <Button 
              variant="contained" 
              onClick={handleProcessContractor}
              disabled={!selectedContractor}
              style={{ marginTop: "10px", marginBottom: "10px"}}
            >
              Обробити
            </Button>

            <select
              className="input-stl"
              style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
              name="rest_id"
              value={fopData.rest_id}
              onChange={handleChange}
              required
            >
              <option value="">Виберіть ресторан</option>
              {contractorRestaurants.map(restaurant => (
                <option key={restaurant.id} value={restaurant.id}>
                  {restaurant.name}
                </option>
              ))}
            </select>

            <br />
            <label style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "auto",
              marginRight: "auto",
              alignItems: "center",
            }}>
              Назва FOP:
              <input
                className="input-stl"
                style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)"}}
                type="text"
                name="name_fop"
                value={fopData.name_fop}
                onChange={handleChange}
                placeholder="Назва FOP"
                required
              />
            </label>
            <button
              className="input-stl"
              style={{ marginTop: "10px" }}
              type="submit"
            >
              Створити FOP
            </button>
          </form>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <Typography variant="h5" gutterBottom>Існуючі FOP</Typography>
          <table>
            <thead>
              <tr>
                <th>Назва FOP</th>
                <th>Контрагент</th>
                <th>Ресторан</th>
                <th>Тип пакету</th>
                <th>Кількість FOP</th>
                <th>Дата оновлення</th>
              </tr>
            </thead>
            <tbody>
              {existingFops.map((fop, index) => (
                <tr key={index}>
                  <td>{fop.name_fop}</td>
                  <td>{fop.contractor_name}</td>
                  <td>{fop.restaurant_name}</td>
                  <td>
                    <select
                      value={fop.pac || ''}
                      onChange={(e) => handleFopAmountChange(fop.contractor_id, e.target.value)}
                    >
                      <option value="">Виберіть пакет</option>
                      {pacOptions.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label} (до {option.limit})
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>{fop.fop_amount}</td>
                  <td>{fop.datesub}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </TabPanel>
      </div>
    </div>
  );
};

export default FOPForm;